// extracted by mini-css-extract-plugin
export default {"h5":"SubHeading_h5__zuOjG"};